module.exports = __webpack_public_path__ + "img/sld_scb_17_t1_b1_green.b7791440.svg";